import { render, staticRenderFns } from "./MarqetaActivateCard.vue?vue&type=template&id=3ac25800&scoped=true"
import script from "./MarqetaActivateCard.vue?vue&type=script&lang=js"
export * from "./MarqetaActivateCard.vue?vue&type=script&lang=js"
import style0 from "./MarqetaActivateCard.vue?vue&type=style&index=0&id=3ac25800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac25800",
  null
  
)

export default component.exports